/** Validation caps — mirror `EmailExecAssistantTemplateService` (the server rejects beyond these). */
export const MAX_KEYWORDS = 100;
export const MAX_KEYWORD_LENGTH = 100;
export const MAX_IGNORE_NOISE_NOTES_LENGTH = 5000;
